const profileDetails = {
  name: "Dr Gayathri Nair",
  location: "Abu Dhabi, UAE",
  website: "https://gayathri.kodothgroup.com",
  email: "gayathrignair3@gmail.com",
  phone: "+971 54 991-6350",
};

const profile = {
  theme: "light",
  projectTitle: profileDetails.name,
  specialty: ["scalable", "efficient", "user-centric solutions"],
  journey: ["medical practitioner", "surgeon"],
  keyAnalyze: [
    "Medical Officer",
    "Medical Practitioner",
    "Assistant Surgeon",
    "General Surgery",
    "Surgical Assisting",
    "Clinical Practice",
    "Patient Care",
    "Emergency Management",
    "Emergency Medical Services (EMS)",
    "Acute Care",
    "Clinical Decision Making",
    "Patient Assessment",
    "Treatment Planning",
    "Medical Documentation",
    "Inpatient Care",
    "Outpatient Care",
    "Primary Healthcare",
    "Healthcare Delivery",
    "Infection Control",
    "Medical Ethics",
    "Team Collaboration",
    "Critical Thinking",
    "Time Management"
  ],
  name: profileDetails.name,
  description: "",
  contact: profileDetails,
  aboutSection: {
    position: "assistant surgeon & medical practitioner",
    description: [
      "I am a dedicated medical practitioner with over three years of experience working as an Assistant Surgeon in a government healthcare setting. My work has given me strong exposure to surgical procedures, emergency care, and day-to-day clinical decision-making, allowing me to handle patients with confidence and responsibility.",

      "I have hands-on experience in surgical assisting, patient assessment, and emergency management. I am comfortable working in high-pressure environments and believe in maintaining accuracy, efficiency, and patient safety at all times. I also value teamwork and clear communication when coordinating with multidisciplinary medical teams.",

      "I hold an MBBS degree and completed my internship with extensive clinical rotations, which built a solid foundation across multiple specialties. I am passionate about improving my clinical skills and staying updated with current medical practices, with the goal of delivering consistent and quality patient care."
    ],
  },
  socialLinks: [
    {
      icon: "In",
      name: "LinkedIn",
      href: "https://www.linkedin.com/in/dr-gayathri-nair-650688293/",
      color: "hover:text-blue-500",
    }
  ],
  experiences: [
    {
      year: "Present",
      title: "Assistant Surgeon",
      company: "Government of Kerala",
      isActive: true,
      delay: 200,
    },
    {
      year: "2022",
      title: "Student Intern",
      company: "A.J. Institute of Medical Science ",
      isActive: false,
      delay: 400,
    }
    // Increase delay by 200 for each entry
  ],
  servicesProvided: [
    {
      title: "Surgical Assisting",
      description:
        "Assist in surgical procedures with precision, ensuring patient safety, proper instrument handling, and adherence to clinical protocols.",
      delay: 200,
    },
    {
      title: "Emergency Care",
      description:
        "Provide immediate assessment and management of emergency cases, ensuring timely and effective treatment in high-pressure situations.",
      delay: 300,
    },
    {
      title: "Patient Care & Management",
      description:
        "Deliver comprehensive patient care including diagnosis support, treatment planning, and continuous monitoring in both inpatient and outpatient settings.",
      delay: 400,
    },
    {
      title: "Pediatric Care",
      description:
        "Assess and manage common pediatric conditions, ensuring age-appropriate care, communication with families, and a compassionate approach to young patients.",
      delay: 500,
    }
  ],

  expertise: [
    {
      title: "General Surgery Support",
      description:
        "Experienced in assisting a wide range of surgical procedures, maintaining sterile techniques, and supporting surgeons throughout operations.",
    },
    {
      title: "Emergency Medicine",
      description:
        "Skilled in handling acute and critical cases, performing rapid assessments, and stabilizing patients efficiently.",
    },
    {
      title: "Clinical Practice",
      description:
        "Strong foundation in patient evaluation, diagnosis, and treatment planning across various clinical scenarios.",
    },
    {
      title: "Pediatrics",
      description:
        "Knowledge of pediatric patient care, including assessment, diagnosis, and management of common childhood illnesses with a patient-centered approach.",
    },
    {
      title: "Patient Assessment",
      description:
        "Conduct detailed patient examinations, interpret clinical findings, and contribute to accurate medical decision-making.",
    },
    {
      title: "Medical Documentation",
      description:
        "Maintain clear and accurate patient records, ensuring compliance with medical standards and continuity of care.",
    },
    {
      title: "Team Collaboration",
      description:
        "Work effectively with multidisciplinary healthcare teams to deliver coordinated and patient-centered care.",
    }
  ],
};

export default profile;
